const IN_YOUR_BAG = {
  GET_IN_YOUR_BAG_ITEMS: 'GET_IN_YOUR_BAG_ITEMS',
  SET_IN_YOUR_BAG_ITEMS: 'SET_IN_YOUR_BAG_ITEMS',
};
//
export const cartKey = '$ROOT_QUERY.getCart';
export const graphQLCacheKey = 'GRAPHQL_CACHED_RESPONSE';
export const cartTimestampKey = 'GET_CART_QUERY';
export const inventoryTimestampKey = 'GET_BASKET_INVENTORY_QUERY';
export const cartInventoryTimestampKey = 'GET_INVENTORY_AND_CART_DETAILS';
export default IN_YOUR_BAG;
